import apiCall from 'apps/catalog/apiCalls/bank';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, EditPage, ListPage } from 'common/ui/admin-CRUD/page';
import ItemForm from './Form';
import { columnsGenerator } from './config';
import ItemDetail from './detail';

export const InvestcoreBankListPage = props => (
  <ListPage
    title="All Banks"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={DynamicFilterForm}
    resourceName="data"
    {...props}
  />
);

export const InvestcoreBankDetailPage = props => (
  <DetailPage
    title="Bank"
    apiCall={apiCall}
    listUrl={`/catalog/banks`}
    ItemDetail={ItemDetail}
    resourceName="data"
    {...props}
  />
);

export const InvestcoreBankEditPage = props => (
  <EditPage
    title="Bank"
    apiCall={apiCall}
    listUrl={`/catalog/banks`}
    detailUrl={`/catalog/banks/:id`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);
